import { Navigate, useParams } from 'react-router';

/**
 * The old full-page PDF viewer URL (`/catalog/article/:artNr/document/:assetId`), kept alive for
 * links and bookmarks that still point at it - now a plain redirect into the overlay viewer
 * (`/catalog/document/:assetId`, see DocumentOverlayPage), which resolves everything it needs from
 * the document index itself and no longer needs the article in the path. Same role SystemDetailPage
 * plays for its own superseded route.
 *
 * `replace` so the redirect doesn't sit in the history between the list and "Schließen".
 */
export const DocumentViewerPage = () => {
    const { assetId } = useParams();

    return <Navigate to={`/catalog/document/${encodeURIComponent(assetId ?? '')}`} replace />;
};
